import { MultiValue } from 'react-select';

import type { AnnouncementsBySportId, AnnouncementsContent, SportOption } from '../types';
import { TimeFilterValue } from '../types';
import type {
  AnnouncementFromBackend,
  AnnouncementsFromBackend,
} from 'app/api/services/live/schedule/types';

const getMsBetweenDates = (now: Date, then: Date) => Math.abs(then.getTime() - now.getTime());
const getHoursBetweenDates = (milliseconds: number) => milliseconds / (60 * 60 * 1000);

const filterAnnouncementByTime = (announcement: AnnouncementFromBackend, time: TimeFilterValue) => {
  const now = new Date();

  const matchStartDate = new Date(announcement.startDate);
  const msBetweenDates = getMsBetweenDates(now, matchStartDate);
  const hoursBetweenDates = getHoursBetweenDates(msBetweenDates);

  return hoursBetweenDates < time;
};

const getFilteredAnnouncement = (announcement: AnnouncementFromBackend, time: TimeFilterValue) => {
  if (time !== TimeFilterValue.ALL_TIME) {
    return filterAnnouncementByTime(announcement, time);
  }

  return true;
};

export const getAnnouncementsAndOptions = (
  data: AnnouncementsFromBackend | null,
  time: TimeFilterValue,
  sportTypes: MultiValue<SportOption>,
) => {
  const announcementsMap: AnnouncementsBySportId = new Map();
  const options: SportOption[] = [];

  if (!data) {
    return { announcements: announcementsMap, options };
  }

  const sportIds = new Set();
  const sportTypeIds = sportTypes.map((sport) => sport.value);

  data.forEach((announcement) => {
    const { sportId, sportName, tournamentId } = announcement;

    if (!sportIds.has(sportId)) {
      sportIds.add(sportId);

      options.push({
        value: sportId,
        label: announcement.sportName,
      });
    }

    if (sportTypeIds.length && !sportTypeIds.includes(sportId)) {
      return;
    }

    if (!getFilteredAnnouncement(announcement, time)) {
      return;
    }

    const announcementsByTournamentId: AnnouncementsContent = announcementsMap.get(sportId) || {
      data: new Map(),
      sportName,
    };

    const announcementsByStages = announcementsByTournamentId.data.get(tournamentId) || [];

    announcementsByStages.push(announcement);
    announcementsByTournamentId.data.set(tournamentId, announcementsByStages);

    announcementsMap.set(sportId, {
      data: announcementsByTournamentId.data,
      sportName,
    });
  });

  return { announcements: announcementsMap, options };
};
